//
// findDuplicateArrayEntries
//
// Provide a list of array entries found at least twice.
// Does NOT do a content based compare for complex objects; this call is more
// suited for arrays of strings, numbers, etc
//

const findDuplicateArrayEntries = (
  dataArray,
  appendToArray = [],
  ignoreUndefined = false,
) => {
  const duplicates = [...appendToArray];
  const existingItems = new Set(duplicates);

  dataArray.forEach((element) => {
    if ((!ignoreUndefined) || (element !== undefined)) {
      if (existingItems.has(element)) duplicates.push(element);
      else existingItems.add(element);
    }
  });

  return duplicates;
};

export default findDuplicateArrayEntries;
